import { Injectable } from '@angular/core';

import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class STRINGS {
  static BTN_EXIT = $localize`:shut it|button label:Close`;
  static BTN_SAVE = $localize`:keep it|button label:Save`;
  static BTN_SEND = $localize`:send it|button label:Submit`;
  static BTN_STOP = $localize`:stop it|button label:Cancel`;

  static BTN_NEXT = $localize`:go to the following item|button label:Next`;
  static BTN_PREV = $localize`:go to the preceding item|button label:Back`;

  static BTN_SIGN_IN = $localize`:button label:Log In`;
  static BTN_SIGN_OUT = $localize`:button label:Log Out`;
  static BTN_SIGN_UP = $localize`:button label:Sign Up`;

  static FLD_EMAIL = $localize`:data label:Email`;
  static FLD_FIRST_NAME = $localize`:data label:First Name`;
  static FLD_LAST_NAME = $localize`:data label:Last Name`;
  static FLD_NATIVE_LOCALE = $localize`:data label:Native Language`;
  static FLD_PASSWORD = $localize`:data label:Password`;
  static FLD_NEW_PASSWORD = $localize`:change it|data label:New Password`;
  static FLD_REF_PASSWORD = $localize`:retype it|data label:Confirm Password`;

  static BRANDNAME = $localize`:@@brandname:FluentStride`;
  static HTML_TITLE = $localize`:@@htmlTitle:Account - ${STRINGS.BRANDNAME}`;
  static SUPPORT_EMAIL = environment.supportEmail;
  static SUPPORT_HREF = `mailto:${STRINGS.SUPPORT_EMAIL}`;

  static ACCOUNT = $localize`:main nav label:Account`;
  static CLASSES = $localize`:main nav label:Classes`;
  static HOME = $localize`:main nav label:Home`;
}
